import { useState } from 'react'

const useRoutingActiveStep = () => {
  const [activeStep, setActiveStep] = useState(0)
  return { activeStep, setActiveStep }
}

export default useRoutingActiveStep
